export default {
  // 基础基本配置
  // baseUrlForBase: 'http://shanghaiqingxun2.devzz.yioks.org:2492',
  baseUrlForBase: 'http://sfa.yioks.cn',
  // baseUrlForBase: process.env.NODE_ENV == 'production' ? 'http://sfa.yioks.cn' : 'http://shanghaiqingxun2.devzz.yioks.org:2492',
  // 基础club配置
  // baseUrlForClub: 'http://shanghaiqingxun.devzz.yioks.org:2492',
  baseUrlForClub: 'http://sfaclub.yioks.cn',
  // baseUrlForClub: process.env.NODE_ENV === 'production' ? 'http://sfaclub.yioks.cn' : 'http://shanghaiqingxun.devzz.yioks.org:2492',
  // club平台域名集合
  clubHostNameList: ['sfaclub.yioks.cn', 'shanghaiqingxun.devzz.yioks.org', 'localhost'],
  baseHostNameList: ['sfa.yioks.cn', 'shanghaiqingxun2.devzz.yioks.org'],

  // 判断平台（club平台、机构平台）
  isClubApp() {
    const hostName = window.location.hostname
    if(this.clubHostNameList.includes(hostName)) {
      return true
    } else {
      return false
    }
  },

  // 地址前缀替换 club =》 机构
  urlTransferToBase(val) {
    if (!val) {
      console.error('url can not be null')
      return
    }
    const transferedUrl = val.replace(this.baseUrlForClub, this.baseUrlForBase)
    return transferedUrl
  },

  // 地址前缀替换 机构 =》 club
  urlTransferToClub(val) {
    if (!val) {
      console.error('url can not be null')
      return
    }
    const transferedUrl = val.replace(this.baseUrlForClub, this.baseUrlForBase)
    return transferedUrl
  },

  // 机构平台将club前缀修改为机构前缀；如服务器配置修改，请根据实际情况调用方法：urlTransferToBase / urlTransferToClub
  transferBaseOnly(val) {
    // console.log('######')  // 输出检测；
    if(this.isClubApp()) {
      return val
    } else {
      return this.urlTransferToBase(val)
    }
  }
}
